import React from "react";
import Pagination from "@mui/material/Pagination";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MemoryMobile from "@components/MemoryMobile";
import useAPI from "@stores/api";
import useFilters from "@stores/filters";
import { highlight } from "@helpers/strings";
import { Search } from "@mui/icons-material";

let onSemanticSearch;

export const RightPanelMobile = () => {
  const data = useAPI((state) => state.data);
  const loading = useAPI((state) => state.loading);
  const responseCode = useAPI((state) => state.responseCode);
  const currentPage = useAPI((state) => state.currentPage);
  const orderBy = useFilters((state) => state.orderBy);
  const isHeaderClickable = useAPI((state) => state.searchMode != "semantic");

  const setCurrentPage = useAPI((state) => state.setCurrentPage);
  const setFilters = useFilters((state) => state.setFilters);

  const semanticQuery = useAPI((state) => state.semanticQuery);
  const setSemanticQuery = useAPI((state) => state.setSemanticQuery);
  const setSearchMode = useAPI((state) => state.setSearchMode);
  const setLastRequestTS = useAPI((state) => state.setLastRequestTS);

  function onOrderByChange(event) {
    const copiaState = JSON.parse(JSON.stringify(orderBy));
    let order = event.target.value ? event.target.value : "date";
    copiaState.map((object) => {
      if (object.name === order) {
        object.is = true;
      } else {
        object.is = false;
      }
      return object;
    });
    setFilters({ orderBy: [...copiaState] });
  }

  function onOrderingChange(event) {
    const copiaState = JSON.parse(JSON.stringify(orderBy));
    let order = event.target.value === "asc" ? "desc" : "asc";
    copiaState.map((object) => {
      object.order = order;
      return object;
    });
    event.target.value = order;
    event.target.innerText = order;
    setFilters({ orderBy: [...copiaState] });
  }

  function handlePageChange(e, value) {
    setCurrentPage(value);
  }

  onSemanticSearch = function () {
    if (semanticQuery.length == 0) return;
    setSearchMode("semantic");
    setLastRequestTS(Date.now());
    if (currentPage != 1) setCurrentPage(1);
    // setIsHeaderClickable(false)
  };

  function onSemanticSearchChange(event) {
    setSemanticQuery(event.target.value);
  }

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [semanticMemory, setSemanticMemory] = React.useState({});
  const [metadataModalOpen, setMetadataModalOpen] = React.useState(false);
  const handleOpen = (e, memory) => {
    setSemanticMemory(memory);
    setMetadataModalOpen(true);
  };
  const handleClose = () => setMetadataModalOpen(false);

  let serverError = (responseCode != 200) & (responseCode != 500);
  let errorMessage = () => {
    switch (responseCode) {
      case 200:
        return "";
      case 429:
        return "Demasiadas peticiones. Espera antes de hacer mas.";
      default: // default error
        return "Error del servidor..";
    }
  };

  return (
    <>
      <div id="rightPanelMobile">
        <div id="rightPanelContent">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "10px",
            }}
          >
            <input
              type="text"
              id="semanticSearch"
              name="semanticSearch"
              placeholder="Introduce el concepto..."
              style={{ fontSize: "15px", width: "50%" }}
              onChange={onSemanticSearchChange}
            ></input>
            <Search id="semantic-search" onClick={onSemanticSearch} />
          </div>
          <div
            id="order"
            style={
              isHeaderClickable ? { display: "block" } : { display: "none" }
            }
          >
            <div>Ordenar por:</div>
            <select
              name="orderer"
              id="orderer"
              onChange={onOrderByChange}
              value={(orderBy.find((o) => o.is) || { name: "date" }).name}
            >
              {orderBy.map((item) => (
                <option key={item.name} value={item.name}>
                  {item.th}
                </option>
              ))}
            </select>
            <button type="button" value="desc" onClick={onOrderingChange}>
              desc
            </button>
          </div>
          <div id="tableContainer">
            <div id="memories-container">
              <table id="memories">
                <tbody>
                  {!("totalMemories" in data) ||
                  (data.totalMemories !== undefined &&
                    data.totalMemories === 0) ? (
                    <tr>
                      <td colSpan={5}>No se han encontrado resultados</td>
                    </tr>
                  ) : (
                    data.memories.map((item) => (
                      <MemoryMobile
                        key={item.id}
                        item={item}
                        handleOpen={handleOpen}
                      />
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div
              id="procesando"
              style={
                loading && !serverError
                  ? { display: "flex" }
                  : { display: "none" }
              }
            >
              <h2>Procesando...</h2>
            </div>
            <div
              id="error"
              style={serverError ? { display: "flex" } : { display: "none" }}
            >
              <h2>{errorMessage()}</h2>
            </div>
            <div className="paginationWrapper">
              <span>
                {" "}
                Mostrando un total de {data.totalMemories || 0} resultados{" "}
              </span>
              <ul>
                <Pagination
                  count={!("totalMemories" in data) ? 0 : data.totalPages}
                  onChange={handlePageChange}
                  page={currentPage}
                  siblingCount={3}
                  color="primary"
                />
              </ul>
            </div>

            <Modal
              open={metadataModalOpen}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Metadata de la búsqueda semántica.
                </Typography>

                <div id="modal-modal-description" sx={{ mt: 2 }}>
                  <p className="ellipsis-overflow">
                    Memoria: {semanticMemory?.name}
                  </p>
                  <p>Página: {semanticMemory?.metadata?.page + 1}</p>
                  Texto:
                  <div className="highlight-container">
                    {highlight(semanticMemory?.metadata?.text)}
                  </div>
                </div>
              </Box>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};
